import React from "react"
import { Container } from "reactstrap"
import PropTypes from "prop-types"

import Footer from "../../components/Footer/"
import "./SearchView.scss"
import SearchBarWithStoreWithData from "../../components/SearchBar/SearchBarWithStoreWithData"
import FacilityAssetsWithStoreWithData from "../../components/FacilityAssets/FacilityAssetsWithStoreWithData"

class SearchView extends React.Component {
  constructor(props) {
    super(props)

    this.state = { searchMode: false }
  }

  handleClick = event => {
    if (this.state.searchMode) {
      this.toggleSearchMode()
    }
  }

  toggleSearchMode = () => {
    this.setState({ searchMode: !this.state.searchMode })
  }

  render() {
    return (
      <div className="search-view-container">
        {/* This container makes the scrollbars on Windows+Chrome 68 consistent */}
        <Container fluid>
          <div
            className={
              this.state.searchMode ? "SearchView search-mode" : "SearchView"
            }
          >
            <SearchBarWithStoreWithData
              searchView={true}
              facilityId={this.props.match.params.facilityId}
              searchMode={this.state.searchMode}
              onSearchMode={this.toggleSearchMode}
              deviceType={this.props.deviceType}
            />
            {!this.state.searchMode ? (
              <FacilityAssetsWithStoreWithData
                facilityId={this.props.match.params.facilityId}
                deviceType={this.props.deviceType}
              />
            ) : (
              <div className="gray-background" onClick={this.handleClick} />
            )}

            <Footer />
          </div>
        </Container>
      </div>
    )
  }
}

SearchView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      facilityId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  deviceType: PropTypes.string.isRequired,
}

SearchView.defaultProps = {
  deviceType: "desktop",
}

export default SearchView
